const { BET_AMOUNT_MULTIPLIER, ODDS_THRESHOLD } = require('../../constants');

const not = (f) => (betslip, states) => !f(betslip, states);
const isLive = (betslip) => betslip?.outcomes.every((outcome) => outcome.isLive);
const isPrematch = (betslip) => betslip?.outcomes.every((outcome) => !outcome.isLive);
const isCombined = (betslip) => betslip?.structure.length > 1;
const isFromSystem = (betslip) => !!betslip?.groupId;
const isSystem = (betslip) => betslip?.betslipType === 3 || isFromSystem(betslip);
const isSimple = (betslip) => betslip?.structure.length === 1;
const hasFreebet = (useFreebet) => (betslip) => !!betslip?.freebet === useFreebet;
const isOutright = (eventId) => !/:match:/.test(eventId);
const isBoostedOdd = (sportId) => sportId === 100000;

const isBetCentsValid = (value) => (betslip) =>
  betslip
    ? Math.round((betslip.betAmount * BET_AMOUNT_MULTIPLIER) % BET_AMOUNT_MULTIPLIER) === value
    : false;

const isSportIdValid = (sportIds) => (betslip) =>
  betslip?.outcomes.every((outcome) => sportIds.includes(outcome.sportId));

const isCategoryIdValid = (categoryIds) => (betslip) =>
  betslip?.outcomes.every((outcome) => categoryIds.includes(outcome.categoryId));

const isTournamentIdValid = (tournamentIds) => (betslip) =>
  betslip?.outcomes.every((outcome) => tournamentIds.includes(outcome.tournamentId));

const isMatchIdValid = (matchIds) => (betslip) =>
  betslip?.outcomes.every((outcome) => matchIds.includes(outcome.matchId));

const isBetTypeIdValid = (typeIds) => (betslip) =>
  betslip?.outcomes.every((outcome) => typeIds.includes(outcome.betTypeId));

const hasNoSportIdsIn = (sportIds) => (betslip) =>
  betslip?.outcomes.every((outcome) => !sportIds.includes(outcome.sportId));

const hasNoCategoryIdsIn = (categoryIds) => (betslip) =>
  betslip?.outcomes.every((outcome) => !categoryIds.includes(outcome.categoryId));

const hasNoTournamentIdsIn = (tournamentIds) => (betslip) =>
  betslip?.outcomes.every((outcome) => !tournamentIds.includes(outcome.tournamentId));

const hasNoMatchIdsIn = (matchIds) => (betslip) =>
  betslip?.outcomes.every((outcome) => !matchIds.includes(outcome.matchId));

const hasNoBetTypesIn = (betTypeIds) => (betslip) =>
  betslip?.outcomes.every((outcome) => !betTypeIds.includes(outcome.betTypeId));

const isMinMyMatchLineValid = (nbLine) => (betslip) =>
  betslip?.structure.every((element) =>
    typeof element === 'object' && 'mymatch' in element
      ? element.mymatch.outcomes.length >= nbLine
      : true
  );

const isMinCombinedBetsValid = (nbBets) => (betslip) =>
  betslip?.structure.filter((element) =>
    typeof element === 'object' && 'mymatch' in element
      ? element.mymatch.odds >= 1
      : betslip?.outcomes.find((o) => o.id === element)?.odds >= 1
  ).length >= nbBets;

const hasMyMatch = (betslip) =>
  betslip
    ? betslip.structure.length === 1 &&
      typeof betslip.structure[0] === 'object' &&
      'mymatch' in betslip.structure[0]
    : false;

const isOddGreaterOrEqualThan = (odd) => (betslip) => betslip?.odds > odd - ODDS_THRESHOLD;

const isBetAmountGreaterOrEqualThan = (amount) => (betslip) => betslip?.betAmount >= amount;

const isMinOddInCombinedValid = (odd) => (betslip) =>
  betslip?.structure.every((element) =>
    typeof element === 'object' && 'mymatch' in element
      ? element.mymatch.odds >= odd || element.mymatch.odds === 1
      : betslip?.outcomes.find((o) => o.id === element)?.odds >= odd ||
        betslip?.outcomes.find((o) => o.id === element)?.odds === 1
  );

const isStartingBeforeMaxStartDate = (maxStartDate) => (betslip, states) =>
  betslip?.outcomes.every((outcome) => states?.[outcome.matchId]?.match?.startTime <= maxStartDate);

const isStartingAfterMinStartDate = (minStartDate) => (betslip, states) =>
  betslip?.outcomes.every((outcome) => states?.[outcome.matchId]?.match?.startTime >= minStartDate);

const isSimpleAndNotMyMatch = (betslip) => isSimple(betslip) && !hasMyMatch(betslip);

const hasBoostedOdd = (useBoostedOdd) => (betslip) =>
  betslip?.outcomes.some((outcome) => isBoostedOdd(outcome.sportId) === useBoostedOdd);

const hasOutright = (useOutright) => (betslip, states) =>
  betslip?.outcomes.some(
    (outcome) => isOutright(states?.[outcome.matchId]?.match.eventId) === useOutright
  );

const hasNoOutrightBuBoostedOdd = (betslip, states) =>
  betslip?.outcomes.every(
    (outcome) => !isOutright(states?.[outcome.matchId]?.match.eventId) || outcome.sportId === 100000
  );

module.exports = {
  not,
  isLive,
  isSimple,
  isPrematch,
  isCombined,
  isSystem,
  isSimpleAndNotMyMatch,
  hasMyMatch,
  isSportIdValid,
  isCategoryIdValid,
  isTournamentIdValid,
  isMatchIdValid,
  isBetTypeIdValid,
  isBetCentsValid,
  isOddGreaterOrEqualThan,
  isBetAmountGreaterOrEqualThan,
  isMinOddInCombinedValid,
  isMinMyMatchLineValid,
  isMinCombinedBetsValid,
  isStartingBeforeMaxStartDate,
  isStartingAfterMinStartDate,
  hasFreebet,
  hasNoSportIdsIn,
  hasNoCategoryIdsIn,
  hasNoTournamentIdsIn,
  hasNoMatchIdsIn,
  hasNoBetTypesIn,
  hasNoOutrightBuBoostedOdd,
  hasBoostedOdd,
  hasOutright,
};
